import { isDateInPast } from '@app/shared/calendar';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const isActionsAllowed = ({
  date,
  schedule,
  mode,
  rights,
}: {
  date: string;
  schedule: boolean;
  mode: NWorkSchedule.ScheduleMode;
  rights: {
    creationInPresentAndFeature: boolean;
    editionInPresentAndFeature: boolean;
    deletionInPresentAndFeature: boolean;
    deletionInPast: boolean;
    editionInPast: boolean;
  };
}) => {
  const {
    creationInPresentAndFeature,
    editionInPresentAndFeature,
    deletionInPresentAndFeature,
    editionInPast,
    deletionInPast,
  } = rights;

  let actionsAllowed = true;

  if (schedule && mode === 'edit' && !editionInPresentAndFeature) {
    actionsAllowed = false;
  }
  if (schedule && mode === 'delete' && !deletionInPresentAndFeature) {
    actionsAllowed = false;
  }
  if (!creationInPresentAndFeature && !schedule) {
    actionsAllowed = false;
  }

  if (schedule && mode === 'edit' && !editionInPast && isDateInPast(date)) {
    actionsAllowed = false;
  }
  if (schedule && mode === 'delete' && !deletionInPast && isDateInPast(date)) {
    actionsAllowed = false;
  }
  if (!schedule && !editionInPast && isDateInPast(date)) {
    actionsAllowed = false;
  }
  return actionsAllowed;
};
